export const CITIES = [
  {
    slug: "orlando",
    name: "Orlando",
    region: "Central Florida",
    intro: "Central Florida claims environment shaped by tropical convective storms, hail events, and inland wind damage.",
    common_claims: ["Wind", "Hail", "Water", "Roof"],
    coords: { x: 60, y: 50 },
  },
  {
    slug: "kissimmee",
    name: "Kissimmee",
    region: "Central Florida",
    intro: "Osceola County properties — residential and short-term rental — represented from filing through recovery.",
    common_claims: ["Wind", "Water", "Roof", "Hurricane"],
    coords: { x: 58, y: 56 },
  },
  {
    slug: "tampa",
    name: "Tampa",
    region: "West Coast",
    intro: "Tampa Bay's residential, condominium, and commercial properties facing surge, wind, and inland flooding risk.",
    common_claims: ["Hurricane", "Wind", "Surge-adjacent water"],
    coords: { x: 40, y: 55 },
  },
  {
    slug: "sarasota",
    name: "Sarasota",
    region: "Gulf Coast",
    intro: "Gulf-coast residential and luxury property claims with high exposure to hurricane wind and surge events.",
    common_claims: ["Hurricane", "Wind", "Water"],
    coords: { x: 38, y: 65 },
  },
  {
    slug: "naples",
    name: "Naples",
    region: "Southwest Florida",
    intro: "High-value coastal residential and condominium claims, including post-Ian re-evaluation and reopened files.",
    common_claims: ["Hurricane", "Surge", "Roof", "Reopening"],
    coords: { x: 40, y: 80 },
  },
];

export const CITY_BY_SLUG = Object.fromEntries(CITIES.map(c => [c.slug, c]));
